import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import StyledModal from './StyledModal';

const PptxDownloadModal = ({ title, downloadUrl, close }) => (
  <StyledModal closeMethod={close} className="download-notification">
    <div>{title}</div>
    <div>
      <p>Your download is ready and will start shortly. If it doesn&apos;t start automatically, <DownloadLink href={downloadUrl}>click here to download manually</DownloadLink>.</p>
    </div>
    <iframe title="Download" src={downloadUrl} style={{ display: 'none' }} />
  </StyledModal>
);

const DownloadLink = styled.a.attrs({
  target: '_blank',
})`
  padding: 0;
`;

PptxDownloadModal.propTypes = {
  title: PropTypes.string,
  downloadUrl: PropTypes.string,
  close: PropTypes.func,
};

export default PptxDownloadModal;



// WEBPACK FOOTER //
// ./app/components/DownloadNotifications/PptxDownloadModal.js